import { api } from './api';

export interface ILoginData {
	username: string;
	password: string;
}

export const user_apis = {
	login: (login_data: ILoginData) => api.post(`/auth/login`, login_data),
};
